<template>
  <div class="text-center">
    <v-dialog persistent v-model="visible" width="600">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Setor
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form" v-if="visible">
            <v-row class="justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  v-model="content.nome"
                  label="Setor*"
                  counter="40"
                  maxlength="40"
                  dense
                  outlined
                  :rules="[(v) => $required(v), (v) => $max(v, 40)]"
                ></v-text-field>
                <v-select
                  v-model="content.origem"
                  label="Origem*"
                  dense
                  outlined
                  return-object
                  :item-text="(v) => v.nome.toUpperCase()"
                  item-value="id"
                  :items="origens"
                  :rules="[(v) => $required(v)]"
                ></v-select>
                <v-select
                  v-model="content.funcoes"
                  label="Funções*"
                  outlined
                  multiple
                  return-object
                  item-text="nome"
                  item-value="id"
                  chips
                  :items="funcoes"
                  :rules="[(v) => $required(v)]"
                ></v-select>
              </v-col>
            </v-row>
          </v-form>
        </div>
        <sigfoco-buttons
          actionText="Salvar"
          @click="salvar()"
          @cancel="$emit('onClose')"
        ></sigfoco-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { Setor } from '~/commons/classes/setor';
import { DialogProps } from '~/commons/classes/dialog-props';
import ManterSetorService from '@/services/manter-setor.service';
import ManterFuncaoService from  '@/services/manter-funcao.service';

export default {
  props: {
    ... new DialogProps(Setor),
    funcoes: {
      type: Array,
      default: () => []
    },
    origens: {
      type: Array,
      default: () => []
    }
  },
  mixins: [ManterSetorService, ManterFuncaoService],
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja confirmar essa operação?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const payload = new Setor(this.content).format();
          return this.edit
            ? this.$editarSetor(this.content.id, payload)
            : this.$cadastrarSetor(payload);
        });
      };

      if (this.$validarFormulario()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
  },
  mounted(){
    this.buscarFuncoes();
  }
}
</script>